import script from "./PageNotFoundView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageNotFoundView.vue?vue&type=script&setup=true&lang=ts"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=dd570f30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd570f30"]])

export default __exports__